import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import EditTestComp from "./Component/EditTestComp"


const EditTest =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EditTestComp />
        </div>
        <Footer />
        </>
    )
}

export default EditTest